import { useaxios } from "../../../utils/useaxios";
export default (document_id, token, title, subtitle, body, notification_type) => {
    return useaxios('send_notification/send_notification.php', { env:"production", document_id, token, title, subtitle, body, notification_type }).then((res) => {
        console.log(res);
        return res;
    });
}